export enum TokenFormat {
  Alphanumeric = 'ALPHANUMERIC',
  Numeric = 'NUMERIC',
}
